

import styled, { css } from 'styled-components';
import {Colors, CSpan, FInter, FlexBox} from '@brg/ui';
import { LayoutConst } from '../../../core';
import { PointWrapper } from '../pointBox/PointBox';

function px(p: string | number): string {
    if (typeof p === 'number') return p + 'px';
    return p;
}

export const ProjectCardDraftWrapper = styled(FlexBox)<{
  img: string
  noGrid?: boolean
}>`
    width: 270px;
    height: 380px;
    max-width: 270px;
    max-height: 380px;
    min-width: 270px;
    min-height: 380px;
    background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%), url('${(p) => p.img}');
    background-position: center center;
    background-size: cover;
    transition: all 0.2s;
    cursor: pointer;

    .meta {
        opacity: 0;
        transition: all 0.2s;
    }
    &:hover .meta {
        opacity: 1;
    }


    justify-content: space-between;
    flex-direction: column;
    padding: 16px 16px 11px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 221.25px;
        height: 311.38px;
        max-width: 221.25px;
        max-height: 311.38px;
        min-width: 221.25px;
        min-height: 311.38px;
    }

    @media (max-width: 940px) {
        width: calc(100vw - 32px);
        height: calc((100vw - 32px) * 1.407);
        max-width: calc(100vw - 32px);
        max-height: calc((100vw - 32px) * 1.407);
        min-width: calc(100vw - 32px);
        min-height: calc((100vw - 32px) * 1.407);
    }
`;
export const ProjectCardContainer = styled(FlexBox)<{
    img: string;
    isLoading?: boolean;
    width?: string;
    height?: string;
}>`
    width: ${(p) => px(p.width ?? 270)};
    height: ${(p) => px(p.height ?? 380)};
    max-width: ${(p) => px(p.width ?? 270)};
    max-height: ${(p) => px(p.height ?? 380)};
    min-width: ${(p) => px(p.width ?? 270)};
    min-height: ${(p) => px(p.height ?? 380)};
    background: url('${(p) => p.img}');
    background-position: center center;
    background-size: cover;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
        max-width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        max-height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
        min-width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        min-height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
    }

    @media (max-width: 940px) {
        width: calc(100vw - 32px);
        height: calc((100vw - 32px) * 1.407);
        max-width: calc(100vw - 32px);
        max-height: calc((100vw - 32px) * 1.407);
        min-width: calc(100vw - 32px);
        min-height: calc((100vw - 32px) * 1.407);
    }
`;

export const ProjectCardWrapper = styled.div<{ img: string; isLoading?: boolean; width?: string; height?: string }>`
    display: flex;
    // Размер карточки - это константа
    width: ${(p) => px(p.width ?? 270)};
    height: ${(p) => px(p.height ?? 380)};
    max-width: ${(p) => px(p.width ?? 270)};
    max-height: ${(p) => px(p.height ?? 380)};
    min-width: ${(p) => px(p.width ?? 270)};
    background: url('${(p) => p.img}');
    background-position: center center;
    background-size: cover;
    transition: all 0.2s;
  
    .meta {
        opacity: 0;
        transition: all 0.2s;
    }

    &:hover,
    &.meta--visible {
        cursor: pointer;
        background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%);
        background-position: center center;
        background-size: cover;
        ${PointWrapper} {
            display: none !important;
          }
        .meta {
            opacity: 1;
        }
    }

    ${(p) =>
        p.isLoading
            ? css`
                  /* background: rgba(255, 255, 255, 0.02) !important; */
                  background: ${(p) => p.theme.skeleton.skeletonBgColor};
                  .meta {
                      opacity: 1 !important;
                  }
              `
            : null}

    justify-content: space-between;
    flex-direction: column;
    padding: 16px 16px 11px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
        max-width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        max-height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
        min-width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        min-height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
    }

    @media (max-width: 940px) {
        width: calc(100vw - 32px);
        height: calc((100vw - 32px) * 1.407);
        max-width: calc(100vw - 32px);
        max-height: calc((100vw - 32px) * 1.407);
        min-width: calc(100vw - 32px);
        min-height: calc((100vw - 32px) * 1.407);
    }
`;

export const ProjectCardWrapperDouble = styled(FlexBox)<{ img: string; isLoading?: boolean }>`
    // Размер карточки - это константа
    width: 270px;
    height: 380px;
    max-width: 270px;
    max-height: 380px;
    min-width: 270px;
    min-height: 380px;
    background: url('${(p) => p.img}');
    background-position: center center;
    background-size: cover;
    transition: all 0.2s;
    .meta {
        opacity: 0;
        transition: all 0.2s;
    }
  
    &:hover,
    &.meta--visible {
        cursor: pointer;
        background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%);
        background-position: center center;
        background-size: cover;
        ${PointWrapper} {
            display: none !important;
          }
        .meta {
            opacity: 1;
        }
    }

    ${(p) =>
        p.isLoading
            ? css`
                  background: rgba(255, 255, 255, 0.02) !important;
                  .meta {
                      opacity: 1 !important;
                  }
              `
            : null}

    justify-content: space-between;
    flex-direction: column;
    padding: 16px 16px 11px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 221.25px;
        height: 311.38px;
        max-width: 221.25px;
        max-height: 311.38px;
        min-width: 221.25px;
        min-height: 311.38px;
    }

    @media (max-width: 940px) {
        width: calc(50vw - 24px);
        height: calc((50vw - 24px) * 1.407);
        max-width: calc(50vw - 24px);
        max-height: calc((50 - 24px) * 1.407);
        min-width: calc(50vw - 24px);
        min-height: calc((50vw - 24px) * 1.407);
    }
`;

export const ProjectCardTitle = styled(FInter.TextBoldDiv)<{
    shouldUseTheme?: boolean,
    color?: string,
    hide?: boolean
}>`
    display: flex;
    width: 100%;
    flex-direction: column;
    row-gap: 12px;
    font-size: 17px;
    line-height: 22px;
    color: ${(p) => p?.color || (p.shouldUseTheme ? p.theme.draftCreate.title : Colors.geoWhite100)};
    word-break: break-word;
    ${({ hide }) => hide ? css` display: none; ` : null};

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-family: Inter;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
    }
`;

export const ProjectCardSubTitle = styled(FInter.TextBoldDiv)<{
    shouldUseTheme?: boolean,
    hide?: boolean
}>`
    display: flex;
    flex-direction: column;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: ${(p) => p.shouldUseTheme ? p.theme.draftCreate.title : Colors.geoWhite100};
    word-break: break-word;
    ${({ hide }) => hide ? css` display: none; ` : null};
`;

export const ProjectCardDraftTitle = styled(CSpan)`
  font-size: 13px;
  line-height: 16px;
  font-weight: ${(p) => p.theme.projectView.authorWeight};


  @media(max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 11px;
    line-height: 13px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    line-height: 18px;
  }
`;

export const OverflowContainer = styled.div<{ isAdaptiveCard?: boolean, lowOpacity?: boolean }>`
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  ${({ isAdaptiveCard }) => isAdaptiveCard && css`
    background: #fff;
  `}

  ${({ lowOpacity }) => lowOpacity && css`
    opacity: 0.5;
  `}
`


import styled, { css } from 'styled-components';
import {Colors, CSpan, FInter, FlexBox} from '@brg/ui';
import { LayoutConst } from '../../../core';
import { PointWrapper } from '../pointBox/PointBox';

function px(p: string | number): string {
    if (typeof p === 'number') return p + 'px';
    return p;
}

export const ProjectCardDraftWrapper = styled(FlexBox)<{
  img: string
  noGrid?: boolean
}>`
    width: 270px;
    height: 380px;
    max-width: 270px;
    max-height: 380px;
    min-width: 270px;
    min-height: 380px;
    background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%), url('${(p) => p.img}');
    background-position: center center;
    background-size: cover;
    transition: all 0.2s;
    cursor: pointer;

    .meta {
        opacity: 0;
        transition: all 0.2s;
    }
    &:hover .meta {
        opacity: 1;
    }


    justify-content: space-between;
    flex-direction: column;
    padding: 16px 16px 11px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 221.25px;
        height: 311.38px;
        max-width: 221.25px;
        max-height: 311.38px;
        min-width: 221.25px;
        min-height: 311.38px;
    }

    @media (max-width: 940px) {
        width: calc(100vw - 32px);
        height: calc((100vw - 32px) * 1.407);
        max-width: calc(100vw - 32px);
        max-height: calc((100vw - 32px) * 1.407);
        min-width: calc(100vw - 32px);
        min-height: calc((100vw - 32px) * 1.407);
    }
`;
export const ProjectCardContainer = styled(FlexBox)<{
    img: string;
    isLoading?: boolean;
    width?: string;
    height?: string;
}>`
    width: ${(p) => px(p.width ?? 270)};
    height: ${(p) => px(p.height ?? 380)};
    max-width: ${(p) => px(p.width ?? 270)};
    max-height: ${(p) => px(p.height ?? 380)};
    min-width: ${(p) => px(p.width ?? 270)};
    min-height: ${(p) => px(p.height ?? 380)};
    background: url('${(p) => p.img}');
    background-position: center center;
    background-size: cover;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
        max-width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        max-height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
        min-width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        min-height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
    }

    @media (max-width: 940px) {
        width: calc(100vw - 32px);
        height: calc((100vw - 32px) * 1.407);
        max-width: calc(100vw - 32px);
        max-height: calc((100vw - 32px) * 1.407);
        min-width: calc(100vw - 32px);
        min-height: calc((100vw - 32px) * 1.407);
    }
`;

export const ProjectCardWrapper = styled.div<{ img: string; isLoading?: boolean; width?: string; height?: string }>`
    display: flex;
    // Размер карточки - это константа
    width: ${(p) => px(p.width ?? 270)};
    height: ${(p) => px(p.height ?? 380)};
    max-width: ${(p) => px(p.width ?? 270)};
    max-height: ${(p) => px(p.height ?? 380)};
    min-width: ${(p) => px(p.width ?? 270)};
    background: url('${(p) => p.img}');
    background-position: center center;
    background-size: cover;
    transition: all 0.2s;
  
    .meta {
        opacity: 0;
        transition: all 0.2s;
    }

    &:hover,
    &.meta--visible {
        cursor: pointer;
        background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%);
        background-position: center center;
        background-size: cover;
        ${PointWrapper} {
            display: none !important;
          }
        .meta {
            opacity: 1;
        }
    }

    ${(p) =>
        p.isLoading
            ? css`
                  /* background: rgba(255, 255, 255, 0.02) !important; */
                  background: ${(p) => p.theme.skeleton.skeletonBgColor};
                  .meta {
                      opacity: 1 !important;
                  }
              `
            : null}

    justify-content: space-between;
    flex-direction: column;
    padding: 16px 16px 11px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
        max-width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        max-height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
        min-width: ${(p) => px(p.width ?? (270 / 1152) * 944)};
        min-height: ${(p) => px(p.width ?? (380 / 1152) * 944)};
    }

    @media (max-width: 940px) {
        width: calc(100vw - 32px);
        height: calc((100vw - 32px) * 1.407);
        max-width: calc(100vw - 32px);
        max-height: calc((100vw - 32px) * 1.407);
        min-width: calc(100vw - 32px);
        min-height: calc((100vw - 32px) * 1.407);
    }
`;

export const ProjectCardWrapperDouble = styled(FlexBox)<{ img: string; isLoading?: boolean }>`
    // Размер карточки - это константа
    width: 270px;
    height: 380px;
    max-width: 270px;
    max-height: 380px;
    min-width: 270px;
    min-height: 380px;
    background: url('${(p) => p.img}');
    background-position: center center;
    background-size: cover;
    transition: all 0.2s;
    .meta {
        opacity: 0;
        transition: all 0.2s;
    }
  
    &:hover,
    &.meta--visible {
        cursor: pointer;
        background: linear-gradient(180deg, rgba(21, 20, 20, 0) 0%, rgba(21, 21, 20, 0.73) 100%);
        background-position: center center;
        background-size: cover;
        ${PointWrapper} {
            display: none !important;
          }
        .meta {
            opacity: 1;
        }
    }

    ${(p) =>
        p.isLoading
            ? css`
                  background: rgba(255, 255, 255, 0.02) !important;
                  .meta {
                      opacity: 1 !important;
                  }
              `
            : null}

    justify-content: space-between;
    flex-direction: column;
    padding: 16px 16px 11px;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 221.25px;
        height: 311.38px;
        max-width: 221.25px;
        max-height: 311.38px;
        min-width: 221.25px;
        min-height: 311.38px;
    }

    @media (max-width: 940px) {
        width: calc(50vw - 24px);
        height: calc((50vw - 24px) * 1.407);
        max-width: calc(50vw - 24px);
        max-height: calc((50 - 24px) * 1.407);
        min-width: calc(50vw - 24px);
        min-height: calc((50vw - 24px) * 1.407);
    }
`;

export const ProjectCardTitle = styled(FInter.TextBoldDiv)<{
    shouldUseTheme?: boolean,
    color?: string,
    hide?: boolean
}>`
    display: flex;
    width: 100%;
    flex-direction: column;
    row-gap: 12px;
    font-size: 17px;
    line-height: 22px;
    color: ${(p) => p?.color || (p.shouldUseTheme ? p.theme.draftCreate.title : Colors.geoWhite100)};
    word-break: break-word;
    ${({ hide }) => hide ? css` display: none; ` : null};

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-family: Inter;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        font-family: Inter;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
    }
`;

export const ProjectCardSubTitle = styled(FInter.TextBoldDiv)<{
    shouldUseTheme?: boolean,
    hide?: boolean
}>`
    display: flex;
    flex-direction: column;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: ${(p) => p.shouldUseTheme ? p.theme.draftCreate.title : Colors.geoWhite100};
    word-break: break-word;
    ${({ hide }) => hide ? css` display: none; ` : null};
`;

export const ProjectCardDraftTitle = styled(CSpan)`
  font-size: 13px;
  line-height: 16px;
  font-weight: ${(p) => p.theme.projectView.authorWeight};


  @media(max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 11px;
    line-height: 13px;
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    line-height: 18px;
  }
`;

export const OverflowContainer = styled.div<{ isAdaptiveCard?: boolean, lowOpacity?: boolean }>`
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  ${({ isAdaptiveCard }) => isAdaptiveCard && css`
    background: #fff;
  `}

  ${({ lowOpacity }) => lowOpacity && css`
    opacity: 0.5;
  `}
`
